import { render, staticRenderFns } from "./ChangeHistoryUpBox.vue?vue&type=template&id=e0855aea&"
import script from "./ChangeHistoryUpBox.vue?vue&type=script&lang=js&"
export * from "./ChangeHistoryUpBox.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistoryUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports